import React from "react";
import { connect } from "react-redux";
import { func } from "prop-types";

import PageContent from "../PageContent";
import { go } from "../../logic/actions/navigation";
import { FACE_LIVENESS_3D } from "../../logic/enums/pages";

import face3DVideo from "../../assets/videos/03-3D-Face.mp4";
import face3DPoster from "../../assets/videos/03-3D-Face.jpg";

PageInstructionVideo3DFL.propTypes = {
  go: func,
};

export function PageInstructionVideo3DFL({ go }) {
  function onStart() {
    go(FACE_LIVENESS_3D);
  }
  return (
    <PageContent>
      <h1 style={{ margin: "5px" }}>Instruction Video</h1>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <video loop autoPlay playsInline width="75%" height="75%" poster={face3DPoster}>
          <source src={face3DVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <button className="btn green" onClick={onStart}>
        Start
      </button>
    </PageContent>
  );
}

export default connect(null, { go })(PageInstructionVideo3DFL);
